import React, { useEffect, useRef, useState } from "react";

// Healthcare & pharma export themed slides.
const SLIDES = [
    {
        src: "https://static.prod-images.emergentagent.com/jobs/8ee9b1d1-2c76-487c-9e03-447b6eaf9a4d/images/ed814ce15a4cdc9c63d2ef66a339386e43053ab343c0e6d64d2f6f86f4a8d761.png",
        alt: "Modern hospital and healthcare facility",
        caption: "Hospitals",
    },
    {
        src: "https://images.pexels.com/photos/139398/pexels-photo-139398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=750",
        alt: "Pharmaceutical capsules and formulations",
        caption: "Formulations",
    },
    {
        src: "https://images.pexels.com/photos/1427107/pexels-photo-1427107.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=750",
        alt: "Container ship exporting healthcare goods",
        caption: "Global Export",
    },
    {
        src: "https://images.pexels.com/photos/8442276/pexels-photo-8442276.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=750",
        alt: "Scientists analysing samples in a modern lab",
        caption: "Laboratory",
    },
    {
        src: "https://images.pexels.com/photos/7108115/pexels-photo-7108115.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=750",
        alt: "Sterile modern operation theatre",
        caption: "Operation Theatre",
    },
];

const SLIDE_MS = 5000; // 5 seconds per slide as requested

export default function HeroSlideshow() {
    const [index, setIndex] = useState(0);
    const timer = useRef(null);

    useEffect(() => {
        timer.current = setInterval(() => {
            setIndex((i) => (i + 1) % SLIDES.length);
        }, SLIDE_MS);
        return () => clearInterval(timer.current);
    }, []);

    return (
        <div
            className="relative w-full aspect-[4/5] overflow-hidden bg-stone-200"
            data-testid="hero-slideshow"
        >
            {SLIDES.map((s, i) => (
                <div
                    key={s.src}
                    className="absolute inset-0 transition-opacity duration-[1200ms] ease-out"
                    style={{
                        opacity: i === index ? 1 : 0,
                        zIndex: i === index ? 2 : 1,
                    }}
                    aria-hidden={i !== index}
                >
                    <img
                        src={s.src}
                        alt={s.alt}
                        className="w-full h-full object-cover"
                        style={{
                            animation:
                                i === index
                                    ? "kenBurns 6.5s ease-out forwards"
                                    : "none",
                        }}
                        loading={i === 0 ? "eager" : "lazy"}
                    />
                    {/* subtle bottom gradient for caption legibility */}
                    <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/40 to-transparent" />
                </div>
            ))}

            {/* Caption overlay (top) */}
            <div className="absolute top-4 left-4 z-10 font-mono text-[10px] uppercase tracking-[0.2em] text-white bg-[#0C4A6E]/85 backdrop-blur-sm px-3 py-1.5">
                0{index + 1} / 0{SLIDES.length} · {SLIDES[index].caption}
            </div>

            {/* Progress bar */}
            <div className="absolute left-0 right-0 bottom-0 h-0.5 bg-white/20 z-10">
                <div
                    key={index}
                    className="h-full bg-[#4D7C0F]"
                    style={{ animation: `grow ${SLIDE_MS}ms linear forwards` }}
                />
            </div>

            {/* Slide dots */}
            <div
                className="absolute bottom-5 left-1/2 -translate-x-1/2 z-10 flex gap-2"
                data-testid="hero-slideshow-dots"
            >
                {SLIDES.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setIndex(i)}
                        aria-label={`Go to slide ${i + 1}`}
                        data-testid={`hero-dot-${i}`}
                        className={`w-2 h-2 rounded-full transition-all duration-300 ${
                            i === index
                                ? "w-8 bg-white"
                                : "bg-white/50 hover:bg-white/80"
                        }`}
                    />
                ))}
            </div>

            <style>{`
                @keyframes kenBurns {
                    0%   { transform: scale(1) translate(0, 0); }
                    100% { transform: scale(1.08) translate(-1%, -1.5%); }
                }
                @keyframes grow {
                    from { width: 0%; }
                    to   { width: 100%; }
                }
            `}</style>
        </div>
    );
}
